import { render } from "./Timestamp.vue?vue&type=template&id=633677d8&ts=true"
import script from "./Timestamp.vue?vue&type=script&lang=ts"
export * from "./Timestamp.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__